import { useReducer } from "react";

const Counter = () => {

    const [counter, dispatch] = useReducer((state, action) => {
        switch(action) { 
            case "increment":
                return state + 5; 
            default:
                return state - 5;
        }
    }, 0)

    return (
        <>
            {counter}
            <button onClick={() => dispatch('increment')}>Increment</button>
            <button onClick={() => dispatch('decrement')}>Increment</button>
        </>
    )
}

export default Counter;